import type {ReactAction} from '@netx/core/bootstrap';
import {performAction} from '@netx/core/lib/utils';
import {faUser} from '@fortawesome/pro-solid-svg-icons';
import {UserActionLabel} from '../locales';

export const userSystemActionUsersIcon = faUser;

/**
 * Route to system users
 * @param params
 * @returns Action
 */
export const userSystemActionUsers = (
	params?: Partial<ReactAction>,
): ReactAction => ({
	name: 'user-system-users',
	cb: () => performAction('system:users:route'),
	icon: userSystemActionUsersIcon,
	label: UserActionLabel.USERS,
	routeMatch: /^system\/users(\/?)/,
	...params,
});

export default userSystemActionUsers;
